// extracted by mini-css-extract-plugin
export var select = "d328afb2d37188496c355dea965ab5c5-css";